import { ConditionRows } from '../controls/ConditionRows.js';
import type { StepEditorProps } from './types.js';

export const FilterStepEditor = ({ step, vars, onChange: put }: StepEditorProps<'filter'>) => {
  return (
    <>
      <p className="text-xs text-ink-subtle">Stop the workflow if these conditions aren’t met.</p>
      <ConditionRows
        conditions={step.conditions}
        vars={vars}
        match={step.match}
        onMatchChange={(m) => put({ ...step, match: m })}
        onChange={(c) => put({ ...step, conditions: c })}
      />
    </>
  );
};
